import { useTranslation } from 'react-i18next'

type ErrorContentProps = {
  message: string
}

const ErrorContent = ({ message }: ErrorContentProps) => {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-col items-center text-center">
      <img src="/icons/beardman-error.svg" alt="error" className="w-40 h-auto" />
      <h2 className="text-lg font-semibold mt-6">{t('components.error.title')}</h2>
      <p className="text-sm text-gray-600 mt-2">{message}</p>
    </div>
  )
}

export default ErrorContent
